import { useState, useEffect } from 'react';
import api from '@/services/api';
import { authService } from '@/services';

interface AOPermission {
  aoId: string;
  permissionType: 'read' | 'write' | 'admin';
}

export function useAOPermissions() {
  const [permissions, setPermissions] = useState<AOPermission[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPermissions();
  }, []);

  const loadPermissions = async () => {
    try {
      if (!authService.isAuthenticated()) {
        setPermissions([]);
        setLoading(false);
        return;
      }

      const { data: response } = await api.get('/users/me/ao-permissions');
      const permissionsData = response?.data?.permissions || [];

      setPermissions(permissionsData);
    } catch (error) {
      console.error('Erreur lors du chargement des permissions:', error);
      setPermissions([]);
    } finally {
      setLoading(false);
    }
  };

  const hasAccess = (aoId: string, requiredLevel: 'read' | 'write' = 'read'): boolean => {
    const permission = permissions.find(p => p.aoId === aoId);
    if (!permission) return false;

    if (requiredLevel === 'read') {
      return true; // Si on a une permission, on peut au moins lire
    }

    return permission.permissionType === 'write' || permission.permissionType === 'admin';
  };

  const getAccessLevel = (aoId: string): 'read' | 'write' | 'admin' | null => {
    const permission = permissions.find(p => p.aoId === aoId);
    return permission?.permissionType || null;
  };

  return {
    permissions,
    loading,
    hasAccess,
    getAccessLevel,
    refreshPermissions: loadPermissions
  };
}
